import { ReactComponent as Asigned } from "../Assets/status-assigned.svg";

const AlreadyAssigned = (props) => {
  return (
    <div className="status d-flex align-items-center justify-content-center">
      <div className="status-inner text-center p-5">
        <>
          <h2 className="font-pnsb text-light mb-4">Thank you!</h2>
          <Asigned />
          <p className="font-pnsb mb-4 mt-4 font-size-32 text-light">
            You have been assigned to the Zixxar.
          </p>
          <a
            rel="noreferrer"
            className="status-gradient m-auto d-flex align-items-center justify-content-center"
            href="https://shop.zixxar.net/">
            <span>Log in to the platform</span>
          </a>
        </>
      </div>
    </div>
  );
};
export default AlreadyAssigned;
